import ColumnWidget from '@components/Widgets/ColumnWidget/ColumnWidget.vue'
import ImageColumn
  from '@components/Widgets/ImageColumnWidget/ImageColumnWidget.vue'
import FortuneWheel
  from '@components/Widgets/FortuneWheelWidget/FortuneWheelWidget.vue'
import mapWidgetPosition from '@components/mixins/shared/mapWidgetPosition'
import { mapActions } from 'vuex'
import watermark from '@components/Widgets/_global/Watermark/Watermark.vue'

export default {
  name: 'PreviewModal',
  mixins: [mapWidgetPosition],
  components: {
    watermark,
    'column-widget-component': ColumnWidget,
    'image-column-widget-component': ImageColumn,
    'fortune-wheel-widget-component': FortuneWheel,
  },
  props: {
    showPreviewModal: {
      type: Boolean,
      required: true,
    },
    targetWidget: {
      type: Object,
      required: true,
    },
    hasWatermark: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      isMobile: false,
    }
  },
  watch: {
    showPreviewModal: () => {
      this.isMobile = false
      this.setWidgetPosition(this.targetWidget)
    },
  },
  created() {
    this.setTargetStep(this.targetWidget.stepsList[0])
    this.setWidgetPosition(this.targetWidget)
  },
  methods: {
    ...mapActions('campaign/step', ['setTargetStep']),
    // closePreviewModal(e) {
    //   const previewedWidget = this.$refs.widget
    //
    //   if (
    //     (typeof previewedWidget !== 'undefined' && !previewedWidget.contains(e.target)) ||
    //     e.target.classList.contains('widget-container')
    //   ) {
    //     if (this.targetWidget.settings.closeOnOverlayClick) {
    //       this.$emit('close')
    //     }
    //   }
    // },
  },
}
